import {
    getHomePath,
    getCategoryPath,
    getPdpPath,
    getPaymentPath,
    getOrderSuccessPath,
    getOrderFailurePath,
    getOrderCancellationPath,
    getCartPath,
    getConfirmationPath
} from './paths';


export const HOME_STEP = 'home';
export const CATEGORY_STEP = 'category';
export const PDP_STEP = 'pdp';
export const PAYMENT = 'payment';
export const ORDER_SUCCESS = 'order_success';
export const ORDER_FAILURE = 'order_failure';
export const ORDER_CANCELLATION = 'order_cancellation';
export const CART_STEP = 'cart';
export const CONFIRMATION_STEP = 'confirmation';
export const REDIRECTION_ORDER_STEP = 'redirection-flow-order';


export const ROUTES = {
    [HOME_STEP]: getHomePath(),
    [CATEGORY_STEP]: getCategoryPath(),
    [PDP_STEP]: getPdpPath(),
    [PAYMENT]: getPaymentPath(),
    [ORDER_SUCCESS]: getOrderSuccessPath(),
    [ORDER_FAILURE]: getOrderFailurePath(),
    [ORDER_CANCELLATION]: getOrderCancellationPath(),
    [CART_STEP]: getCartPath(),
    [CONFIRMATION_STEP]: getConfirmationPath()
};


export const currencyPickerAllowedPages = [HOME_STEP, PDP_STEP, CATEGORY_STEP];


export const manageGiftcardsAllowedPages = [HOME_STEP, PDP_STEP, CONFIRMATION_STEP, ORDER_CANCELLATION];




export const loginButtonAllowedPages = [HOME_STEP, CATEGORY_STEP, PDP_STEP, CART_STEP, PAYMENT];


export const cartIconNotAllowedPagesInMobileView = [CART_STEP];


export const restrictedPagesForLocaleUpdate = [PAYMENT, ORDER_SUCCESS, ORDER_FAILURE, ORDER_CANCELLATION];


export const PAGE_TITLE_MESSAGE_IDS = {
    [HOME_STEP]: 'homePageTitle',
    [CATEGORY_STEP]: 'categoryPageTitle',
    [PDP_STEP]: 'pdpPageTitle',
    [PAYMENT]: 'paymentPageTitle',
    [ORDER_SUCCESS]: 'orderSuccessPageTitle',
    [ORDER_FAILURE]: 'orderFailurePageTitle',
    [ORDER_CANCELLATION]: 'orderCancellationPageTitle',
    [CART_STEP]: 'cartPageTitle',
    [CONFIRMATION_STEP]: 'confirmationPageTitle'
};
